import {
    chakra,
    Box
} from '@chakra-ui/react';

/**
 * Container manages the iframe overflow separate from fixed header and left nav.
 */
export const RouteContainer = chakra(Box, {
    label: 'RouteContainer',
    baseStyle: {
        fontFamily: 'Poppins, sans-serif',
        w: 'calc(100% - 70px)',
        h: '100%',
        mt: '60px',
        overflow: 'auto',
        position: 'relative'
    }
});
